import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bqub3wwmta: FaireBrandEntity = {
  token: "b_bqub3wwmta",
  type: "brand",
  name: "B4homemade, LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/cc5d82b8b886972e2734fc6cf6bb376ee01ceb9498cc70f3269cb5926606630d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8912328add3b68a3c2b3b348165a7600b6418131dc6973cf6782463efb7f1b52.png",
  logoUrl:
    "https://cdn.faire.com/fastly/cc5d82b8b886972e2734fc6cf6bb376ee01ceb9498cc70f3269cb5926606630d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8912328add3b68a3c2b3b348165a7600b6418131dc6973cf6782463efb7f1b52.png",
  location: "Baltimore, MD, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "We are Dawn & Michael, owners of B4homemade. We are a family-owned and operated small business located in Maryland that started in 2019. Dawn worked in the corporate world for 25+ years and loved her job until she didn't.  I knew I needed to do something that made my heart happy again.  Michael encouraged me to do what I love. I went for it and started B4homemade with all of my Hubby's support and help.   Deciding to start this small business has been so rewarding.  I love creating and making the products we offer.  Michael also works full-time as a product Buyer for a wonderful company. He does his part when needed for B4. He is a great partner in both business and life. He goes along with most of my crazy ideas and finds my weird sense of humor entertaining.  \n\nWe create a variety of items, including but not limited to my most popular baby onesies, t-shirts for both children & adults, customizable and snarky tea towels & tote bags, laser-engraved stainless steel tumblers, cutting boards, coasters, wood signs and so much more.  \n\nI love meeting and working with other small businesses that share our style.  Each purchase made contributes to our dream and we appreciate all of our customers. \n\nI hope you take a chance and put our product in your shop!  ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:20.605Z",
    importedBy: "entity-db-cli",
  },
};
